// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"497d5d3b","166":"141ac3fc","177":"f6914948","812":"f356bc4a","964":"93ba8cdb","976":"6280edc2","988":"c52300f6"}[chunkId] + ".chunk.js";
};